import { toUpper } from 'lodash';
import { useQuery, useSession } from 'common/hooks';
import { UseQueryOptions } from 'common/types/Api.type';
import { GetStaticDataDetailsParams } from '../types';
import { OrganizationalTagPagesTypeEnum } from '../static-data.enum';
import { StaticDataInfoModel } from '../models';
import { getTagDetailsApi } from 'features/tags/services/taggings.service';

export const useGetStaticDataDetails = (
  params: GetStaticDataDetailsParams,
  options: UseQueryOptions = {},
) => {
  const { account } = useSession();
  const organizationId = account.organizationId || '';
  const { type, id } = params;
  const staticDataType = type && (toUpper(type) as OrganizationalTagPagesTypeEnum);

  const isValidStaticDataType =
    !!staticDataType &&
    Object.values(OrganizationalTagPagesTypeEnum).includes(staticDataType);

  const queryResponse = useQuery(
    [organizationId, 'static-data', staticDataType, id],
    () => isValidStaticDataType && getTagDetailsApi({ type: staticDataType, id }),
    {
      enabled: !!organizationId && isValidStaticDataType,
      showErrorSnackbar: true,
      select: (result) => {
        return { data: new StaticDataInfoModel(result.data) };
      },
      ...options,
    },
  );

  return {
    ...queryResponse,
    data: queryResponse?.data?.data as StaticDataInfoModel,
  };
};
